/* unplugin-vue-components disabled */import script from "./message-audio.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-audio.vue?vue&type=script&lang=ts&setup=true"

import "./message-audio.vue?vue&type=style&index=0&id=2821b3c7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2821b3c7"]])

export default __exports__